import { render } from "./DSVG.vue?vue&type=template&id=8a621514"
import script from "./DSVG.vue?vue&type=script&lang=js"
export * from "./DSVG.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__